import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useLocation } from 'react-router';
import googleLogo from '../assets/img/google.svg';
import { GOOGLE_AUTH_URL } from '../constants';

import useIsTouchDevice from './../common/hooks';

const SocialSignup = (props) => {
  const location = useLocation();
  const { i18n } = useLingui();
  const color = location.pathname == '/signup' ? 'text-white' : 'text-black';

  const isTouchDevice = useIsTouchDevice();

  return (
    <div>
      {!isTouchDevice ? (
        <div className="block">
          <div className="flex flex-row items-center w-full justify-center">
            <p
              className={`text-center m-[9px] ${color}`}
              style={{
                fontStyle: 'normal',
                fontWeight: '400',
                fontSize: '16px',
                lineHeight: '16px',
                color: '#172B4D',
              }}
            >
              <Trans>Hoặc đăng nhập tài khoản bằng</Trans>{' '}
            </p>
            <a
              className="block mx-2"
              href={GOOGLE_AUTH_URL + '?redirect=' + props.redirect}
            >
              <img
                className={'w-8 inline-block'}
                src={googleLogo}
                alt="Google"
              />
            </a>
            {/* <a className="block mx-2" href={FACEBOOK_AUTH_URL + "?redirect=" + props.redirect}>
        <img className={'w-8 inline-block'} src={fbLogo} alt="Facebook"/>
      </a> */}
            {/* <a className="block" href={GITHUB_AUTH_URL + "?redirect=" + props.redirect}>
        <img className={'w-8 inline-block'} src={githubLogo} alt="Github"/>
        <span className={'mx-1 inline-block'}>Github</span>
      </a> */}
          </div>
        </div>
      ) : (
        <div className="block">
          <div className="flex flex-row items-center w-full justify-center ml-1">
            <p
              className={`text-center ${color}`}
              style={{
                fontStyle: 'normal',
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '16px',
              }}
            >
              <Trans>Hoặc đăng nhập tài khoản bằng</Trans>{' '}
            </p>
            <a
              className="block mx-1 mt-1"
              href={GOOGLE_AUTH_URL + '?redirect=' + props.redirect}
            >
              <img
                className={'w-8 inline-block'}
                src={googleLogo}
                alt="Google"
              />
            </a>
            {/* <a className="block mx-2" href={FACEBOOK_AUTH_URL + "?redirect=" + props.redirect}>
        <img className={'w-8 inline-block'} src={fbLogo} alt="Facebook"/>
      </a> */}
            {/* <a className="block" href={GITHUB_AUTH_URL + "?redirect=" + props.redirect}>
        <img className={'w-8 inline-block'} src={githubLogo} alt="Github"/>
        <span className={'mx-1 inline-block'}>Github</span>
      </a> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialSignup;
